<template>
    <div>
      <div class="darenInfoContainer clear">
          <div class="contentLeft">
              <div class="part1" v-loading="loadingObj.darenInfo">
                  <div class="part1_top">
                      <span>快手短视频主页<i class="el-icon-copy-document" v-clipboard:copy="`https://www.kuaishou.com/profile/${darenInfo.profileId}`" v-clipboard:success="onCopy"></i></span>
                      <i class="qrCode">
                          <div class="erweima">
                              <vue-qr v-if="darenInfo.base64_qrcode" :text="darenInfo.base64_qrcode" :size="360"></vue-qr>
                              <p>打开快手APP</p>
                              <p>首页搜索扫一扫</p>
                          </div>
                      </i>
                  </div>
                  <div class="part1_center">
                      <div class="clear">
                          <div class="imgWrap">
                              <img v-if="$route.query.logings === '签约号' && authorDrinfo.contract_type=='独家'" src="@/assets/images/djdr.png" style=" margin: 2px auto;"  >
                              <img v-else-if="$route.query.logings === '签约号' && ['非独家，不分商机先后','非独家，优先商机'].includes(authorDrinfo.contract_type)" src="@/assets/images/fdjdr.png" style=" margin: 2px auto;" >
                              <img v-else-if="$route.query.logings === '签约号' && authorDrinfo.contract_type=='弱绑定签约达人'" src="@/assets/images/rbddr.png" style=" margin: 2px auto;"  >
                              <img class="avatar" :src="darenInfo.headUrl || crmTalentInfo.avatar_uri || defaultAvatar" alt="">
                          </div>
                          <div class="name">
                              <p class="talent-name">
                                <span class="flex_align">
                                    <img v-if="authorDrinfo?.month_examples_data?.is_hot == '是'" :src="require(`@/assets/images/火爆.png`)" style="margin-right: 4px;vertical-align: baseline;">
                                    <img v-if="authorDrinfo?.month_examples_data?.is_must == '是'" :src="require(`@/assets/images/必选.png`)" style="margin-right: 4px;vertical-align: baseline;">
                                    <el-tooltip placement="top" :content="darenInfo.name || crmTalentInfo.nickname">
                                        <span class="nickname">{{darenInfo.name || crmTalentInfo.nickname}}</span>
                                    </el-tooltip>
                                    <i v-if="darenInfo.name" class="el-icon-copy-document" style="margin-left:5px;" v-clipboard:copy="`${darenInfo.name}`" v-clipboard:success="onCopy"></i>
                                    <span class="tag-g" v-if="authorDrinfo?.month_examples_data?.discount" >{{authorDrinfo?.month_examples_data?.discount}}折</span>

                                </span>

                              </p>
                              <p><span>{{darenInfo.fansNumber || '-'}}</span><i> 粉丝</i>
                                <!-- <i>ID: {{darenInfo.userId}}</i> -->
                              </p>
                              <p v-if="$route.query.shortid">
                                <i>
                                    平台账号ID(UID):{{$route.query.shortid||"-"}} <i v-if="darenID" class="el-icon-copy-document"  v-clipboard:copy="`${$route.query.shortid}`" v-clipboard:success="onCopy"></i>
                                </i>
                              </p>
                          </div>

                      </div>
                      <div class="newTag">

                          <i class="isChangwan" v-if="darenInfo.identify">{{darenInfo?.identify || ''}}</i>
                          <template v-else>
                            <el-tooltip placement="top" :content="darenInfo?.polarisTag?.secondTagName" v-if="darenInfo?.polarisTag?.firstTagName">
                                <i class="isChangwan">{{darenInfo?.polarisTag?.firstTagName}}</i>
                            </el-tooltip>
                          </template>

                        <!-- <span class="isChangwan" v-if="isChangwanDaren">畅玩达人</span> -->

                            <el-popover
                                v-if="$route.query.logings"
                                title=""
                                width="200"
                                trigger="hover"
                                :disabled="!is_product || (!$route.query.logings.includes('合作号') && !$route.query.logings.includes('野生'))"
                                @show="onLogingsPopShow()"
                                @hide="logingsContent = ''">
                                <div v-html="logingsContent"></div>
                                <span class="isChangwan" slot="reference" v-if="$route.query.logings">{{['合作号', '野生'].includes($route.query.logings) ? '合作号/野生' : $route.query.logings}}</span>
                                <!-- 只有合作号和野生才有弹窗 -->
                            </el-popover>
                            <img v-if="['自孵化号','签约号'].includes($route.query.logings)" src="@/assets/images/schedule/i-calendar.png" class="i-calendar" style="vertical-align: middle;margin-left: 6px;" alt=""
                        @click="showCalendarDia">
                      </div>
                      <div class="icon-group"  style="margin-top: 8px;">
                            <img v-if="authorDrinfo.is_month_examples == '1'" :src="require('@/assets/images/bykl.png')">
                            <el-tooltip v-if="authorDrinfo.bl_status == '是'" effect="dark" content="该达人支持保量或历史合作项目中有保量案例，具体条款详见合作明细。" placement="top">
                                <img :src="require(`@/assets/images/支持保量.png`)"  >
                            </el-tooltip>

                            <img v-if="authorDrinfo.is_cooling == 1" :src="require(`@/assets/images/冷却.png`)"  >
                            <img v-if="authorDrinfo.isHistorySign" :src="require(`@/assets/images/历史签约号.png`)"  >
                            <el-tooltip v-if="authorDrinfo.isNewSign" effect="dark" content="1、首次入库，成为签约号的前三个自然月。2、非首次入库，从别的账号状态(例如野生)首次改成签约号的前三个自然月。3、非首次入库，从签约号状态改成别的状态(例如野生)再改回签约号的前三个自然月。" placement="top">
      <img :src="require(`@/assets/images/新签约.png`)"  >
    </el-tooltip>
                        </div>
                        <div class="info-form-wrap">
                            <div class="form-item" >
                                <div class="label">分成税率%</div>
                                <div class="value">
                                    {{authorDrinfo.devidedtax || '-'}}
                                </div>
                            </div>
                            <div class="form-item" >
                                <div class="label">媒体侧自然返点%</div>
                                <div class="value">
                                    {{$route.query.logings === '签约号' ? (authorDrinfo.org_devidedrate || '-') : (authorDrinfo.devidedrate || '-')}}
                                </div>
                            </div>
                            <div class="form-item isWhole" >
                                <div class="label">分成比例说明</div>
                                <div class="value">
                                     {{authorDrinfo.devidedratedesc || '-'}}
                                </div>
                            </div>
                        </div>
                        <div v-if="authorDrinfo.is_black == 1 || authorDrinfo.is_sup_black == 1 || authorDrinfo?.history_black_data" class="alert " @click="authorDrinfo.is_black == 1 || authorDrinfo.is_sup_black == 1 ? null : authorDrinfo?.history_black_data ? hadBlack() : null">
                            <i class="el-icon-warning"></i>
                            <el-tooltip placement="top"  :content="`拉黑理由：${(authorDrinfo.is_black == 1 || authorDrinfo.is_sup_black == 1) ? authorDrinfo?.black_data?.black_reasons : authorDrinfo?.history_black_data ? authorDrinfo?.history_black_data?.black_reasons :'-'}`">
                                <span v-if="authorDrinfo.is_black == 1">达人已被加入畅玩达人黑名单</span>
                                <span v-else-if="authorDrinfo.is_sup_black == 1">达人归属供应商被拉黑</span>
                                <span v-else-if="authorDrinfo?.history_black_data">最近有被加入畅玩达人黑名单</span>
                            </el-tooltip>
                        </div>
                        <div v-if="authorDrinfo?.ban_data?.reason" class="alert ">
                            <i class="el-icon-warning"></i>
                            <el-tooltip placement="top"  :content="'不推荐理由：'+authorDrinfo?.ban_data?.reason || '-'">
                                <span>公司不推荐与该达人合作</span>
                            </el-tooltip>
                        </div>
                        <div class="info-form-wrap" style="margin-top: 12px;">
                            <div class="hr"></div>
                            <div class="form-item isWhole" v-if="industryTag">
                                <div class="label">所属行业</div>
                                <div class="value">{{ industryTag }}</div>
                            </div>
                            <div class="hr"></div>
                            <template v-if="crmTalentInfo.special_saletype">
                                <div class="form-item isWhole">
                                    <div class="label">特殊售卖类型</div>
                                    <div class="value">
                                        <img :src="require(`@/assets/images/${crmTalentInfo.special_saletype}.png`)" style="height: 24.23px;" >
                                    </div>
                                </div>
                                <div v-if="crmTalentInfo.special_saledesc" class="form-item isWhole">
                                    <div class="label">特殊售卖描述</div>
                                    <div class="value">
                                        {{crmTalentInfo.special_saledesc || '-'}}
                                    </div>
                                </div>
                                <div class="hr"></div>
                            </template>
                            <div class="form-item">
                                <div class="label">性别</div>
                                <div class="value">
                                    {{darenInfo.gender || '-'}}
                                </div>
                            </div>
                            <div class="form-item">
                                <div class="label">地区</div>
                                <div class="value">
                                    {{darenInfo.address || '-'}}
                                </div>
                            </div>
                            <div class="form-item">
                                <div class="label">机构</div>
                                <div class="value">
                                    {{darenInfo.govName || '-'}}
                                </div>
                            </div>
                            <div class="hr"></div>
                            <div class="form-item isWhole">
                                    <div class="label">主页链接</div>
                                    <div class="value">
                                        <span class="is-ellipsis">{{crmTalentInfo.homepage || '-'}}  </span>
                                        <i class="el-icon-copy-document" v-clipboard:copy="crmTalentInfo.homepage" v-clipboard:success="onCopy"></i>
                                    </div>
                                </div>
                            <template v-if="!hide_fields.includes('devidedrate')">
                                <div class="form-item isWhole">
                                    <div class="label">达人联系方式</div>
                                    <div class="value linkinfo-wrap">
                                        {{contact.phone || "***********"}}
                                        <i v-if="contact.phone && contact.phone !== '暂无'"
                                            class="el-icon-copy-document"
                                            v-clipboard:copy="`${contact.phone}`"
                                            v-clipboard:success="onCopy">
                                        </i>
                                        <i v-if="!contact.phone" class="el-icon-view show" @click="getContactWay(2)"> 查看</i>
                                    </div>
                                </div>
                                <div class="form-item isWhole">
                                    <div class="label">企微群二维码</div>
                                    <div class="value linkinfo-wrap">
                                        <img v-if="contact.wxQr"
                                            :class="{'img-qr': true, 'img-big': contact.wxQr && contact.isGetQr}"
                                            :src="contact.wxQr" alt="企微群二维码"
                                            @click="getContactWay(3)">
                                        <span v-else>暂无</span>
                                    </div>
                                </div>
                                <div class="hr"></div>
                            </template>
                            <div class="form-item isWhole">
                                <div class="label">达人评价</div>
                                <div class="value">
                                    {{authorDrinfo.evaluation || '-'}}
                                </div>
                            </div>
                            <div class="form-item isWhole">
                                <div class="label">入库运营</div>
                                <div class="value">
                                    {{authorDrinfo.signoperation || '-'}}
                                </div>
                            </div>
                            <div v-if="logings == '签约号'" class="form-item isWhole">
                                <div class="label">mcn商务运营</div>
                                <div class="value">
                                    {{authorDrinfo.mcn_buname || '-'}}
                                </div>
                            </div>
                            <div v-if="logings == '签约号'" class="form-item isWhole">
                                <div class="label">mcn签约经纪人</div>
                                <div class="value">
                                    {{authorDrinfo.mcn_uname || '-'}}
                                </div>
                            </div>
                            <div class="hr"></div>
                            <template v-if="crmTalentInfo.last_contract">
                                <div class="form-item isWhole">
                                    <div class="label">签约状态</div>
                                    <div class="value">
                                        {{ signStatus }}
                                    </div>
                                </div>
                                <div class="form-item isWhole">
                                    <div class="label">签约有效期</div>
                                    <div class="value">
                                        {{ crmTalentInfo.last_contract.sign_dt+'至'+crmTalentInfo.last_contract.due_dt }}
                                    </div>
                                </div>
                                <div class="hr"></div>
                            </template>
                            <div class="form-item isWhole">
                                <div class="label">推荐理由</div>
                                <div class="value">
                                    {{ authorDrinfo?.month_examples_data?.reason || '-' }}
                                </div>
                            </div>
                            <div class="form-item isWhole">
                                <div class="label">最新发布时间</div>
                                <div class="value">
                                    {{ crmTalentInfo.last_video_time || '-' }}
                                </div>
                            </div>
                        </div>
                  </div>
              </div>

              <div class="part2">
                  <span class="part2Title">
                    达人服务报价
                    <el-tooltip v-if="authorDrinfo?.month_examples_data?.is_same_price == '否'" effect="dark" placement="top-start">
                        <template #content>
                            <span>该达人实际接单价格与平台不一致，其他备注说明：{{authorDrinfo?.month_examples_data?.notes}}</span>
                        </template>
                        <i class="el-icon-warning-outline"></i>
                    </el-tooltip>
                  </span>
                  <div class="price2">
                    <!-- ￥{{(darenInfo.orderBid&&darenInfo.orderBid!=='1')?darenInfo.orderBid:"-"}} -->
                    <div v-for="(item,i) in darenInfo.priceShowInfo" :key="i">
                      <a href="javascript:void(0);" class="priceItem">
                          <span>{{item.priceTypeName}}</span>
                          <!-- <i>￥{{item.price ? fmt(item.price/1000/10000,{micrometer: true}) +"w": '-'}}</i> -->
                          <i>￥{{item.price ? (item.price/1000).toLocaleString() : '-'}}</i>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="hr"></div>
                  <span class="part2Title">认证信息</span>
                  <p class="info">{{darenInfo.verifiedInfo?darenInfo.verifiedInfo:"无"}}</p> -->
                  <!-- <div class="hr"></div>
                  <p>想要获取更好的营销效果？尝试让达人同步进行直播</p>
                  <a href="javascript:void(0);" class="toBroadcast">前往查看达人直播主页</a>  -->
              </div>
              <div class="part2">
                  <span class="part2Title">达人所属机构</span>
                  <div class="subContent">
                    {{ darenInfo.govName }}
                  </div>
              </div>
          </div>
          <div class="contentRight">
              <el-tabs v-model="activeName" class="tabTop">
                <template v-if="darenID">
                  <el-tab-pane label="达人概览" name="达人概览"><Outline v-if="activeName==='达人概览'&&darenInfo.name" :darenID="darenID" :fatherDarenInfo="darenInfo" :supplierList="supplierList"></Outline></el-tab-pane>
                  <el-tab-pane label="传播表现" name="传播表现"><Expression v-if="activeName==='传播表现'" :darenID="darenID"></Expression></el-tab-pane>
                  <el-tab-pane label="受众分析" name="受众分析"><Analysis v-if="activeName==='受众分析'" :darenID="darenID"></Analysis></el-tab-pane>
                  <el-tab-pane label="电商带货" name="电商带货">
                    <!-- <Goods v-if="activeName==='电商带货'" :darenID="darenID"></Goods> -->
                    <LiveStreamingEcommerce  v-if="activeName==='电商带货'" :fatherDarenInfo="darenInfo" :darenID="darenID"></LiveStreamingEcommerce>
                  </el-tab-pane>
                </template>
                  <!-- <el-tab-pane label="聚星案例" name="聚星案例" v-if="$store.state.auth.showCooperAnalysis == 1"><Example v-if="activeName==='聚星案例'"></Example></el-tab-pane> -->
                  <!-- <el-tab-pane label="合作案例" name="合作案例" v-if="$store.state.auth.showCooperAnalysis == 1"><Cooperation v-if="activeName==='合作案例'" :userId="darenInfo.userId" :idsInfo="idsInfo"></Cooperation></el-tab-pane> -->

                <el-tab-pane label="合作案例" name="合作案例" ><Cooperation2 v-if="activeName==='合作案例'" :plat="'快手'"></Cooperation2></el-tab-pane>

              </el-tabs>
          </div>
          <Calendar :outerDiaVisible.sync="outerDiaVisible" :info="calendarInfo"></Calendar>
      </div>
    </div>
  </template>

  <script>
  import Cooperation2 from "../daren/Cooperation/Cooperation2.vue";
  import tools from "../../components/tools/tools.js";
  import Outline from "./Outline/Outline.vue";
  import Expression from "./Expression/Expression.vue";
  import Analysis from "./Analysis/Analysis.vue";
  import Goods from "./Goods/Goods.vue";
  import Example from "./Example/Example.vue";
  import Cooperation from "./Cooperation/Cooperation.vue";
  import VueQr from 'vue-qr'
  import CryptoJS from 'crypto-js';
  export default {
    name: "kauishou",
    props:[],
    data(){
      return {
          defaultAvatar: require('@/assets/images/avatar.jpg'),
          //达人基础信息
          darenID:'',
          darenInfo:{},
          activeName: '达人概览',//当前tab
          isChangwanDaren:false,
          outerDiaVisible: false,
          calendarInfo: {},
          idsInfo: {},
          contact: {
            phone: "",
            wxQr: require("./images/icon_4.png"),
            isGetQr: false,
            loading: false
          },
          hide_fields: [],
          crmTalentInfo: {},
          logingsContent: "",
          is_product: false,
          authorDrinfo: {},
          loadingObj: {
            darenInfo: false
          },
          supplierList:[]
      }
    },
    components:{
      Outline,
      Expression,
      Analysis,
      Goods,
      LiveStreamingEcommerce:()=>import('./LiveStreamingEcommerce/LiveStreamingEcommerce.vue'),
      Example,
      Cooperation,
      Cooperation2,
      VueQr,
      Calendar: () => import("@/components/calendar/calendar.vue")
    },
    computed:{
        // 所属行业
        industryTag(){
            if (Array.isArray(this.darenInfo.industryTag)) {
               return this.darenInfo.industryTag.map(x => x.firstTagName + '-' + x.secondTagName).join()
            } else {
               return null
            }
        },
        // 签约状态
        signStatus(){
            const today = this.dayjs().format("YYYY-MM-DD")
            const last_contract = this.crmTalentInfo.last_contract
            if (!last_contract) {
                return '-'
            } else if (today>last_contract.due_dt){
                return '已过期'
            } else if (today>=last_contract.sign_dt&&today<= last_contract.due_dt){
                return '已签约'
            } else {
                return '-'
            }
        },
        logings() {
            const logings = this.$route.query.logings || ''
            if (['合作号', '野生'].includes(logings)) {
                return '合作号/野生'
            } else {
                return logings
            }
        },
    },
    watch: {
        activeName: {
            handler() {
                if(this.activeName === "合作案例") {
                    // 合作案例埋点
                    let logParams = {
                        type: 5,
                        plat: 2,
                        shortid: this.darenInfo.userId,
                        starid: this.darenInfo.starId || ""
                    }
                    this.$api.setUseLog(logParams)
                }
            }
        }
    },
    methods:{
      hadBlack(){
            let blackType = '最近有被加入畅玩达人黑名单'
            this.$alert(`
            <div style="display: flex; align-items: center">
                <i class="el-icon-warning" style="font-size: 50px; color: #FF6F28;margin-right: 10px"></i>
                <div>
                    <p>${blackType}，拉黑理由：</p>
                    <p style="font-weight: 600; color: #FF6F28;">${this.authorDrinfo?.history_black_data?.black_reasons || '-'}</p>
                </div>
            </div>
            `, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了'
            });
      },
      onCopy(){
        this.$message.success('已复制到剪切板')
      },
      showCalendarDia() {
          this.outerDiaVisible = true
      },
      async getKsPortrait(){
        await this.$api.getKuaishouData.getKsPortrait('/'+this.darenID).then((res) => {
          window.sessionStorage.setItem('getKsPortrait',JSON.stringify(res));
        })
      },
     async getCrmTalentInfo() {
        // 获取达人评价 新接口
        const res = await this.$axios.get('/api.php?m=index|api|gx&a=talentDetail', {
            params: {
                starid: this.$route.query.id || '',
                shortid: this.$route.query.shortid || '',
                plat:2,
            },
            headers: {
                showLoading: false
            }
        })
        res.special_saletype = res.special_saletype?.split(',')?.filter(item => item !== '促销' && item)?.[0]

        // 3个月前的日期节点
        const newSignDateFlag = this.dayjs().subtract(3, 'month')
        // 历史签约号
        res.isHistorySign = res.logings !== '签约号' && res.has_sign == 1
        // 新签约号，当前是签约号，并且签约时间在3个月内
        res.isNewSign = res.logings == '签约号' && newSignDateFlag.isBefore(res.last_sign_time)

        this.crmTalentInfo = res
        this.authorDrinfo = res
        if(res.mcn==='畅玩文化'){
            this.isChangwanDaren=true
        }
        if (this.is_product && this.logings == '合作号/野生') {
            this.getSupplierData(this.crmTalentInfo.id)
        }

        if(this.authorDrinfo.is_black == 1 || this.authorDrinfo.is_sup_black == 1) {
            let blackType = this.authorDrinfo.is_black == 1 ? '达人已被加入畅玩达人黑名单' : '达人归属供应商被拉黑'
            this.$alert(`
    <div style="display: flex; align-items: center">
                <i class="el-icon-warning" style="font-size: 50px; color: #FF6F28;margin-right: 10px"></i>
                <div>
                    <p>${blackType}，拉黑理由：</p>
                    <p style="font-weight: 600; color: #FF6F28;">${this.authorDrinfo?.black_data?.black_reasons || '-'}</p>
                </div>
            </div>
    `, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了'
            });
        }
    },
      getContactWay(type) {
        if(type === 3 && this.contact.isGetQr) return
        this.contact.loading = true
        // plat=(3=观星数据,4=媒体库)
        // type=(2=联系方式,3=群二维码,4=身份证,5=手机号，6=银行卡号)
        let params = {
            mid: this.crmTalentInfo.id, //媒体库id
            sign: CryptoJS.MD5(`${this.crmTalentInfo.id},${localStorage.getItem('uid')}`).toString(), //id和shortidMD5
            type,
            plat:3
        }
        this.$axios.get(`api.php?m=detail|api|gx&a=getContact`, {params, headers: {showLoading: false}}).then(res => {
            if(type === 2) {
                this.contact.phone = res.contactmode || '暂无'
            }else if(type === 3) {
                this.contact.wxQr = res.qr_code || ''
                this.$nextTick(() => {
                    this.contact.isGetQr = true
                })
            }
        }).finally(() => {
            this.contact.loading = false
        })
      },
      onLogingsPopShow() {
        this.$axios.get(`/api.php?m=index|api|gx&a=getProductlogings&mid=${this.crmTalentInfo.id}`, {headers: { showLoading: false, hideTip: true }}).then(res => {
            if(!res?.length) {
                this.logingsContent = "暂无数据"
                return
            }
            let obj = {}, str = ""
            res.forEach(x => {
                if(!obj[x.account_type]) {
                    obj[x.account_type] = []
                }
                obj[x.account_type] = [...obj[x.account_type], x.product_name]
            })

            Object.keys(obj).forEach(x => {
                str += `<p style="font-weight: 800;margin: 10px 0 0">${x}：</p>${obj[x].join('，')};`
            })
            this.logingsContent = str
        }).catch( err => console.log('err :>> ', err))
      },
      async getSupplierData(id) {
        this.$axios.get('/api.php?m=index|api|gx&a=getProductlogings', { params:{ mid: id }}).then(resdata => {
            this.supplierList = resdata
        })
      },
    },
    beforeRouteEnter (to, from, next) {
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
        next()
    },
    async created(){
      this.darenID = this.$route.query.id
        this.hide_fields = JSON.parse(localStorage.getItem("ks_hide_fields")) || []
      this.is_product = localStorage.getItem("gx_is_product") ? JSON.parse(localStorage.getItem('gx_is_product')) : ""
      this.getCrmTalentInfo()
        let darenInfo
        let darenInfoCache = window.sessionStorage.getItem('getKsProfile')
        // 达人基础数据
        if(darenInfoCache){
            darenInfo = JSON.parse(darenInfoCache)?.data?.data
        } else if(this.darenID){
            this.loadingObj.darenInfo = true
            const res = await this.$api.getKuaishouData.getKsProfile('/'+this.darenID)
            this.loadingObj.darenInfo = false
            darenInfo = res.data.data
            window.sessionStorage.setItem('getKsProfile',JSON.stringify(res));
        }
        if(darenInfo){
        console.log('darenInfo :>> ', darenInfo);
        darenInfo.fansNumber = tools.setW(darenInfo.fansNumber || 0)
        darenInfo.industryTagStr = darenInfo.industryTagStr?darenInfo.industryTagStr.split(","):""
        darenInfo.starTagStr = darenInfo.starTagStr?darenInfo.starTagStr.split(","):""
        darenInfo.orderBid = tools.setThousands(darenInfo.orderBid/1000)
        darenInfo.base64_qrcode = 'http://k.kuaishou.com/jump.html?profileUrl=kwai://profile/'+darenInfo.userId
        this.darenInfo = darenInfo;
        this.calendarInfo = {
            plat: "快手",
            shortid: this.darenInfo.userId,
            starid: this.darenInfo.starId || ""
        }
        this.idsInfo = {
            shortid: this.darenInfo.userId,
            starid: this.darenInfo.starId || ""
        }
        if(this.darenInfo.mcn.includes("畅玩达人")){
            this.isChangwanDaren = true;
        }
        }
        if(this.darenID){
      // 达人粉丝分析
      this.$api.getKuaishouData.getKsFans('/'+this.darenID).then((res) => {
        window.sessionStorage.setItem('getKsFans',JSON.stringify(res));
      })
      await this.getKsPortrait()
        } else {
            // 不存在 this.darenID（starid）时，只显示合作案例
            this.activeName = '合作案例'
            // this.$message.warning(`该达人的磁力聚星数据获取失败，你可以在本页面查看该达人的基础信息和历史合作信息~`)
        }
    },
    mounted() {

    }
  }
  </script>

  <style scoped lang="less">
  .alert {
        margin: 10px 0;
        border-radius: 4px;
        background-color: #e5e6eb;
        font-family: '苹方 常规体', '苹方', sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #4E5969;
        box-sizing: border-box;
        font-size: 14px;
        height: 28px;
        display: flex;
        align-items: center;

        i {
            font-size: 16px;
            vertical-align: middle;
            margin: 0 10px;
            color: #a9aeb8;
        }
    }
    .subContent{
      font-size: 12px;
      color:#999999;
    }
      .flex_align{
        display: flex;
        align-items: center;
    }
    .nickname{
        display: block;
        max-width: 88px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
      .price2 {
          margin-bottom: 20px;
          font-size: 18px;
          font-family: OPPOSans;
          font-weight: 800;
          color: #ff5c00;
      }
      .industry{
          padding-top: 10px;
      }
      .industry span{
          margin-top: 16px;
          color: #333;
          font-size: 12px;
          line-height: 20px;
          font-weight: 700;
      }
      .industry p{
          margin-top: 8px;
          color: #999;
          font-size: 12px;
          line-height: 18px;
      }
      .industry p i{
          display: inline-block;
          margin-right: 10px;
      }

      .darenInfoContainer{
          width: 1300px;
          margin: 16px auto 40px;
      }
      .contentLeft{
          float: left;
          width: 320px;
          height: 100px;
          background: #fff;
          border-radius: 6px;
      }

      .contentLeft .part1{
          position: relative;
          width: 100%;
        //   padding-bottom: 24px;
          background: #FFFFFF;
          border-radius: 6px;
      }
      .contentLeft .part1 .part1_top{
          width: 100%;
          height: 57px;
          line-height: 57px;
          padding-left: 24px;
          border-bottom: 1px solid #E8E8E8;
          box-sizing: border-box;
          font-size: 14px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #333333;
          text-align: left;
      }
      .contentLeft .part1 .part1_top span{
          float: left;
      }
      .contentLeft .part1_top .qrCode{
          float: left;
          width: 24px;
          height: 24px;
          margin-top: 16px;
          margin-left: 12px;
          background: #F5F5F5 url("./images/icon_4.png") no-repeat center;
          cursor: pointer;
      }
      .contentLeft .part1_top .qrCode:hover{
          background-image: url("./images/icon_5.png");
          background-color: #FFF2EB;
      }
      .contentLeft .part1_top .qrCode:hover .erweima{
          display: block;
      }


  /* topTitle tab公共样式 start*/

    .darenInfoContainer /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      color: #FF5C00;
      background-color: #FFF2EB;
      border-color: #FF5C00;
      box-shadow: -1px 0 0 0 #FF5C00;
    }
    .darenInfoContainer /deep/ .el-radio-button__inner:hover{
      color: #333;
    }
    .darenInfoContainer /deep/ .el-radio-button__inner{
      padding: 10px 16px;
    }
    .darenInfoContainer /deep/ .el-radio-button:first-child .el-radio-button__inner{
      border-radius: 2px 0 0 2px;
    }
    .darenInfoContainer /deep/ .el-radio-button:last-child .el-radio-button__inner{
      border-radius: 0
    }

    /* topTitle tab公共样式 end*/
      .part1_top .erweima{
          display: none;
          position: absolute;
          top: 15px;
          left: 170px;
          padding: 20px 0 40px;
          width: 180px;
          box-shadow:0px 0px 5px rgba(0,0,0,.1);
          background: #fff;
          border-radius: 4px;
          text-align: center;
          z-index: 999;
      }
      .part1_top .erweima::before{
          position: absolute;
          top: 8px;
          left: -5px;
          content: "";
          width:0;
          height:0;
          border-width:6px 6px 6px 0;
          border-style:solid;
          border-color:transparent #fff transparent transparent;
          z-index: 1;
      }
      .part1_top .erweima::after{
          position: absolute;
          top: 8px;
          left: -6px;
          content: "";
          width:0;
          height:0;
          border-width:6px 6px 6px 0;
          border-style:solid;
          border-color:transparent rgba(0,0,0,.08) transparent transparent;
          filter: blur(1px);
      }

      .part1_top .erweima img{
          display:inline-block;
          width: 120px;
          height: 120px;
          margin-bottom: -12px;
      }
      .part1_top .erweima p{
          margin: 0;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #999999;
          text-align: center;
      }
      .part1_center{
          padding: 26px 20px 10px;
          box-sizing: border-box;
      }
    //   没发现以下类名的引用
    //   .part1_center .industry2{
    //       position: relative;
    //       padding-top: 10px;
    //   }
    //   .part1_center .industry2 i{
    //       position: absolute;
    //       bottom: 4px;
    //       right: 0;
    //       padding-left: 40px;
    //       font-size: 12px;
    //       font-family: OPPOSans;
    //       font-weight: 500;
    //       color: #38A1FF;
    //       cursor: pointer;
    //       background: linear-gradient(left,rgba(255,255,255,0)4%,rgba(255,255,255,1)60%) ;
    //   }
    //   .part1_center .industry2 span{
    //       margin-top: 16px;
    //       color: #333;
    //       font-size: 12px;
    //       line-height: 20px;
    //       font-weight: 700;
    //   }
    //   .part1_center .industry2 p{
    //       margin-top: 8px;
    //       color: #999;
    //       font-size: 12px;
    //       line-height: 18px;
    //   }
    //   .part1_center .industry2 p.flod{
    //       display: -webkit-box;
    //       -webkit-box-orient: vertical;
    //       -webkit-line-clamp: 2;
    //       overflow: hidden;
    //   }

      .part1_center .imgWrap{
          float: left;
          width: 60px;
          margin-right: 12px;

      }
      .part1_center .imgWrap .avatar{
          display: block;
          border-radius: 50%;
          width: 60px;
          height: 60px;
      }
      .part1_center .name{
          float: left;
          width: calc(100% - 72px);
          .talent-name{
              display: flex;
              align-items: center;

          }
      }
      .part1_center .newTag .isChangwan{
          display: inline-block;
          margin-top: 4px;
          margin-left: 5px;
          /* width: 56px; */
          padding: 0 6px;
          height: 20px;
          line-height: 20px;
          background: #fff2eb;
          color: #ff5c00;
          border-radius: 2px;
          text-align: center;
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 500;
      }
      .part1_center .name p{
          margin: 0;
          margin-bottom: 4px;
          text-align: left;
      }
      .part1_center .name span{
        //   margin-right: 6px;
          font-size: 16px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #333333;
      }
      .part1_center .name i{
        //   margin-right: 8px;
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #999999;
      }
      .part1_center .name i:nth-of-type(2){
          margin-right: 0;
      }
      .part1_center .tag {
          display: inline-block;
          line-height: 26px;
          border-radius: 2px;
          font-size: 14px;
          font-family: OPPOSans;
          font-weight: 400;
          color: #333333;
      }
      .special_saletype{
            padding-top: 0;
            padding-bottom: 20px;
            .industry2{
                display: flex !important;
                padding-top: 0 !important;
                padding-bottom: 10px !important;
                font-family: OPPOSans;
                font-weight: 500;
                line-height: 20px;
                font-size: 12px;
                >span{
                    margin: 0 10px 0 0 !important;
                    white-space: nowrap;
                    color: #999999;
                }
                >p{
                    margin: 0 !important;
                    color: #333;
                }
            }
        }
      .part1_bottom{
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
      }
      .part1_bottom .item{
          float: left;
          width: 50%;
          margin-top: 8px;
      }
      .part1_bottom span{
          margin-right: 14px;
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #999999;
      }
      .part1_bottom .item span:nth-of-type(2){
          color: #333;
      }
      .part1_bottom .des{
          position: relative;
          margin-top: 8px;
      }
      .part1_bottom .des span{
          float: left;
      }
      .part1_bottom .des p{
          float: left;
          width: 242px;
          margin: 0;
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
      }
      .part1_bottom .des i{
          position: absolute;
          bottom: 4px;
          right: 0;
          padding-left: 40px;
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #38A1FF;
          cursor: pointer;
          background: linear-gradient(left,rgba(255,255,255,0)4%,rgba(255,255,255,1)60%) ;
      }
      .part1_bottom .des p.flod{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
      }
      .part2 {
          width: 320px;
          margin-top: 16px;
          padding: 0 20px 20px;
          background: #FFFFFF;
          border-radius: 6px;
          box-sizing: border-box;
      }
      .part2 .info{
          margin-top: 0;
      }
      .part2 .part2Title{
          width: 100%;
          height: 50px;
          line-height: 50px;
          font-size: 14px;
          font-family: OPPOSans;
          font-weight: 600;
          color: #333333;
      }
      .part2 .priceItem{
          display: block;
          width: 100%;
          height: 52px;
          margin-bottom: 16px;
          padding: 0 20px;
          background: #FFFFFF;
          border: 1px solid #F0F0F0;
          border-radius: 2px;
          box-sizing: border-box;
      }
      .part2 .priceItem:hover{
          border-color: #FF5C00;
      }
      .part2 .priceItem span{
          float: left;
          line-height: 52px;
          font-size: 14px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #999999;
      }
      .part2 .priceItem i{
          float: right;
          line-height: 52px;
          font-size: 16px;
          font-family: OPPOSans;
          font-weight: 800;
          color: #FF5C00;
      }
      .part2 p{
          font-size: 12px;
          font-family: OPPOSans;
          font-weight: 400;
          color: #666666;
      }
      .part2 .toBroadcast{
          display: block;
          width: 100%;
          height: 34px;
          line-height: 34px;
          background: #FFF2EB;
          border-radius: 2px;
          font-size: 14px;
          font-family: OPPOSans;
          font-weight: 400;
          text-align: center;
          color: #FF5C00;
      }
      .contentRight{
          float: right;
          width: 964px;
          /deep/ .el-tabs__header{
            position: sticky;
            top: 0;
            z-index: 10;
          }
      }
      .contentRight /deep/ .el-tabs__active-bar{
          background-color: #FF5C00!important;
      }
      .contentRight /deep/ .el-tabs__item{
          color: #333;
          height: 50px;
          line-height: 50px;
      }
      .contentRight /deep/ .el-tabs__nav-scroll {
          height: 50px;
          padding-left: 24px;
          background: #fff;
          border-radius: 6px;
      }
      .contentRight /deep/ .el-tabs__item.is-active {
          color: #333;
      }
      .contentRight /deep/ .el-tabs__header{
        //   margin-bottom: 15px;
      }
      .contentRight /deep/ .el-tabs__content{
          margin-top: 15px;
      }
      .contentRight /deep/ .el-tabs__nav-wrap::after{
          height: 1px;
          background: #f5f5f5;
      }
      .part1_center .item:nth-child(1){
          margin-top: 14px;
      }
    //   .linkinfo-wrap{
    //     // margin-top: 10px;
    //     >p{
    //         font-size: 12px;
    //         color: #333;
    //         i{
    //             cursor: pointer;
    //         }
    //         .show{
    //             font-size: 12px;
    //             font-family: OPPOSans;
    //             font-weight: 500;
    //             color: #38A1FF;
    //             cursor: pointer;
    //             float: right;
    //         }
    //     }
    //     .img-qr{
    //         width: 20px;
    //         height: 20px;
    //         vertical-align: text-top;
    //         cursor: pointer;
    //         &.img-big{
    //             width: 100px;
    //             height: 100px;
    //         }
    //     }
    //   }

    // 改版新增样式
    .block-title{
        line-height: 50px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
    }
    .info-form-wrap{
        font-size: 14px;
        // font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        .hr{
            margin-bottom: 12px;
        }
        .form-item{
            margin-bottom:12px;
            &.isWhole{
                width: 100%;
            }
            width:50%;
            display: inline-flex;
            line-height: 1.5em;
            .label{
                flex:none;
                min-width: 0;
                // color:rgb(78, 89, 105);
                margin-right: 8px;
                color: #333;
                font-size: 12px;
                font-weight: 700;
            }
            .value{
                flex:1;
                word-break: break-all;
                overflow-wrap: break-word;
                font-size: 12px;
                // font-family: OPPOSans;
                font-weight: 500;
                display: flex;
                align-items: center;
                img{
                    vertical-align: middle;
                }
                .is-ellipsis{
                    display: inline-block;
                    max-width: 200px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

        }
    }
    // 联系方式
    .linkinfo-wrap{
        i{
            cursor: pointer;
            margin-left: 4px;
            vertical-align: middle;
        }
        .show{
            margin-left: 8px;
            font-family: OPPOSans;
            font-weight: bold;
            color: #38A1FF;
            cursor: pointer;

        }
        .img-qr{
            width: 14px;
            height: 14px;
            vertical-align: text-top;
            cursor: pointer;
            &.img-big{
                width: 100px;
                height: 100px;
            }
        }
    }
    .i-calendar {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        cursor: pointer;
    }
    .tag-g {
        margin: 0 4px;
        color: #00b42a !important;
        padding: 4px 6px 4px 6px;
        background-color: #e6f8ea;
        border-radius: 4px;
        line-height: 12px;
        font-size: 10px  !important;
        display: inline-block;
    }

    .icon-group {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-flow: row wrap;
    }
  </style>
